module.exports = __webpack_public_path__ + "static/media/plusIcon.85a20852.svg";